import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import DashboardSolicitacaoService from "../../services/resource/dashboardSolicitacaoService";

const service = new DashboardSolicitacaoService();

export function useDashboardSolicitacoes() {
    const [dashboard, setDashboard] = useState(null);
    const [loading, setLoading] = useState(true);

    const carregar = useCallback(() => {
        setLoading(true);
        service.buscarDashboard()
            .then(res => setDashboard(res.data))
            .catch(error => {
                console.error("Erro ao carregar dashboard de solicitações", error);
                toast.error("Erro ao carregar o dashboard");
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        carregar();
    }, [carregar]);

    return { dashboard, loading, recarregar: carregar };
}
